module.exports = __webpack_public_path__ + "media/jingle_game_over.4561b69b.mp3";